import React, { Component } from "react";
import styles from './styles.css'

import Container from '../../../components/Container'
import Title from '../../../components/Title'
import Button from '../../../components/Button'
import ContactForm from '../../../components/ContactForm'

class Contact extends Component {
  constructor(props) {
    super(props)

    this.formSubmitted = this.formSubmitted.bind(this)

    this.state = {
      formSubmitted: false
    }
  }

  formSubmitted(result) {
    this.setState({
      formSubmitted: result
    })
  }

  render() {
    let form

    if(this.state.formSubmitted) {
      form = <h2 className="contact__title">Thank you for your submission!</h2>
    } else {
      form = (
        <div>
          <h2 className="contact__title">Send me a message!</h2>
          <ContactForm onFormSubmission={this.formSubmitted} />
        </div>
      )
    }

    return (
      <div>
        <Title direction='right'>Contact</Title>
        <Container align='center'>
          <Button href="https://resume.mattpatterson.xyz" target="_blank">View Resume</Button>
        </Container>

        <Container align='center'>
          {form}
        </Container>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/parts/home/Contact/index.js